"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildArrayMetadataWithElement = buildArrayMetadataWithElement;
function buildArrayMetadataWithElement(newMetadata) {
    return (arrayMetadata) => {
        arrayMetadata.push(newMetadata);
        return arrayMetadata;
    };
}
//# sourceMappingURL=buildArrayMetadataWithElement.js.map